export const careersNavBar =(displayName)=> [
  {
    text: displayName|| "Careers Submission",
    icon: "mdi-account-group",
    to: "/careers",
  },
];
